var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M13.60781,12L9.72893,8.28169C9.4236899,7.989572,9.4236899,7.511749,9.72893,7.219627C10.033421,6.9267909,10.53216,6.9267909,10.8374,7.219627L15.26601,11.46432C15.26751,11.46575,15.26976,11.466470000000001,15.27126,11.4679C15.42425,11.61431,15.5,11.80716,15.5,12C15.5,12.19284,15.42425,12.38569,15.27126,12.5321C15.26976,12.53425,15.26751,12.53425,15.26601,12.53568L10.8374,16.780369999999998C10.53216,17.0732,10.033421,17.0732,9.72893,16.780369999999998C9.4236899,16.48825,9.4236899,16.01043,9.72893,15.71831L13.60781,12Z",
    fillRule: "evenodd",
    fill: "#FFFFFF",
    fillOpacity: 1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.90761fb28660a2c530208f069ca63090.svg";
export { ForwardRef as ReactComponent };